<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" md="7" lg="7">
        <div class="pa-2">
          <v-card class="pa-5 rounded-lg" color="var(--g)" flat>
            <h1 class="white--text txtLarge notBold">
              Welcome to
              <span>
                <b> Integrated Learning Management Platform </b>
              </span>
            </h1>
            <div class="d-flex align-center my-4" v-if="profile">
              <v-avatar dark size="100" class="mr-3">
                <img
                  :src="
                    profile.profile_picture ? profile.profile_picture : avalg
                  "
                  alt="avatar"
                  class="obj_fit"
                />
              </v-avatar>
              <div>
                <h1 class="txtLarge white--text notBold">
                  {{ profile.name }}
                </h1>
                <p class="ma-0 white--text">
                  {{ permissions[0] }}
                </p>
              </div>
            </div>
            <h4 class="txtSmall white--text notBold">
              Nice to have you back, what an exciting day! Get ready and
              continue your lesson today.
            </h4>
          </v-card>
          <div v-if="permissions.includes('TEACHER') && overview">
            <div class="d-flex align-center justify-space-between">
              <h3 class="color_default">Your Course</h3>
              <div class="d-flex align-center justify-center">
                <v-btn v-if="step == 1" icon>
                  <v-icon> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn color="black" v-if="step > 1" icon @click="step -= 1">
                  <v-icon> mdi-chevron-left </v-icon>
                </v-btn>

                <v-btn class="ml-3" v-if="step == last" icon>
                  <v-icon> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="ml-3"
                  v-if="step !== last"
                  icon
                  @click="step += 1"
                >
                  <v-icon color="black"> mdi-chevron-right </v-icon>
                </v-btn>
              </div>
            </div>

            <v-card flat class="pa-3 rounded-lg">
              <v-stepper v-model="step" class="ma-0" flat>
                <v-stepper-items>
                  <v-stepper-content
                    v-for="(item, i) in overview"
                    :key="i"
                    style="margin: 0; padding: 0"
                    :step="i + 1"
                  >
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-progress-circular
                          value="80"
                          size="130"
                          color="var(--g)"
                          width="18"
                          rotate="270"
                          class="progress-circular"
                        />
                      </v-col>
                      <v-col cols="12" md="9">
                        <div>
                          <h2 class="txtMediumSmall">
                            {{ item.courseTitle }}
                          </h2>
                          <b class="color_default">
                            {{ item.courseCategoriesName }}
                          </b>
                        </div>
                        <div class="d-flex align-center mb-2">
                          <v-icon class="mr-2">mdi-book</v-icon>
                          <p class="default_txt">
                            {{ item.courseSectionsCount }} Section
                          </p>
                        </div>
                        <div class="d-flex align-center mb-2">
                          <v-icon class="mr-2">mdi-book</v-icon>
                          <p class="default_txt">
                            {{ item.courseModulesCount }} Module
                          </p>
                        </div>
                        <div class="d-flex align-center">
                          <v-icon class="mr-2">mdi-account</v-icon>
                          <p class="default_txt">
                            {{ item.courseScholarCount }} Scholars
                          </p>
                        </div>

                        <v-btn
                          dark
                          depressed
                          class="mt-3 text-capitalize rounded-lg"
                          width="300px"
                          height="50px"
                          color="var(--g)"
                          :to="`/course/inclass/${item.courseId}`"
                        >
                          <b class="txtSmall">Go To Course</b>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card>
          </div>
          <div
            v-if="
              permissions.includes('FASILITATOR') ||
              permissions.includes('MENTOR')
            "
          >
            <v-card class="pa-5 mt-4 rounded-lg" flat v-if="overview">
              <div class="d-flex align-center justify-space-between">
                <h3 class="color_default">Your Course</h3>
                <div class="d-flex align-center justify-center">
                  <v-btn v-if="step == 1" icon>
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn color="black" v-if="step > 1" icon @click="step -= 1">
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>

                  <v-btn class="ml-3" v-if="step == last" icon>
                    <v-icon> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-btn
                    class="ml-3"
                    v-if="step !== last"
                    icon
                    @click="step += 1"
                  >
                    <v-icon color="black"> mdi-chevron-right </v-icon>
                  </v-btn>
                </div>
              </div>
              <v-divider class="my-3"></v-divider>
              <v-stepper v-model="step" class="ma-0" flat>
                <v-stepper-items>
                  <v-stepper-content
                    v-for="(item, i) in overview"
                    :key="i"
                    style="margin: 0; padding: 0"
                    :step="i + 1"
                  >
                    <div>
                      <h2 class="txtMediumSmall">
                        {{ item.title }}
                      </h2>
                      <b class="color_default">
                        {{ item.data_category.name }}
                      </b>
                    </div>
                    <v-btn
                      dark
                      depressed
                      class="mt-3 text-capitalize rounded-lg"
                      width="300px"
                      height="50px"
                      color="var(--g)"
                      :to="`/facilitator/inclass/facilitator/inclass/${item.id}`"
                    >
                      <b class="txtSmall">Check Schedule</b>
                    </v-btn>
                    <div class="mt-3">
                      <div class="d-flex align-center mb-3">
                        <h3>Scholar You Manage</h3>
                        <div class="ml-3 around_m">
                          <b class="color_default">{{ item.member.length }}</b>
                        </div>
                      </div>
                      <v-card
                        flat
                        color="#f6f6f6"
                        class="pa-3 rounded-lg mb-3 d-flex justify-space-between"
                        v-for="(member, idx) in item.member"
                        :key="`member_ke_${idx}`"
                      >
                        <div>
                          <router-link
                            class="opener_name d-flex align-center"
                            :to="`/scholar/${member.user_id}`"
                          >
                            <v-avatar size="35" class="mr-5">
                              <img
                                :src="
                                  member.profile_picture
                                    ? member.profile_picture
                                    : ava
                                "
                                class="obj_fit"
                                alt="isyan"
                              />
                            </v-avatar>
                            <div>
                              <h4 class="black--text">{{ member.name }}</h4>
                              <p class="default_txt">{{ member.no_tf }}</p>
                            </div>
                          </router-link>
                        </div>
                        <v-icon color="var(--g)" @click="toPrivateChat(member)"
                          >mdi-chat</v-icon
                        >
                      </v-card>
                    </div>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card>
          </div>
        </div>
      </v-col>
      <!-- LIST SCHEDULE -->
      <v-col cols="12" md="5" lg="5" class="pa-2">
        <v-card
          :class="showTimeline ? 'historyDefault' : 'rounded-lg'"
          flat
          style="overflow: hidden"
        >
          <div
            :class="
              showTimeline
                ? 'trigger_timeline mt-10 rounded-lg'
                : 'trigger_timeline rounded-lg'
            "
          >
            <v-btn
              class="btn_trigger_timeline"
              icon
              small
              @click="showTimeline = !showTimeline"
            >
              <v-icon v-if="!showTimeline">mdi-chevron-up</v-icon>
              <v-icon v-if="showTimeline">mdi-chevron-down</v-icon>
            </v-btn>
          </div>
          <div>
            <div
              :class="
                showTimeline
                  ? 'colorWhite expand_history rounded-t-lg'
                  : 'collapse_history rounded-t-lg'
              "
            >
              <v-card flat style="overflow: hidden" class="rounded-t-lg">
                <list-schedule
                  :deadline="deadline"
                  v-if="!permissions.includes('TEACHER')"
                />
                <list-report-teacher :deadline="deadline" v-else />
              </v-card>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListReportTeacher from "../../components/listScheduleVendor/listReportTeacher.vue";
import ListSchedule from "../../components/listScheduleVendor/listSchedule.vue";
export default {
  components: { ListSchedule, ListReportTeacher },
  name: "vendorOverview",
  computed: {
    ...mapState({
      profile: (state) => state.profile,
      ava: (state) => state.ava,
      avalg: (state) => state.ava_lg,
      permissions: (state) => state.permissions,
    }),
  },

  data() {
    return {
      runningPersen: 80,
      upcomingPersen: 0,
      toggle: false,
      showTimeline: false,
      offsetTop: 0,
      coursePage: 0,
      showAllScholar: false,

      step: 1,
      loading: false,
      overview: null,
      deadline: null,
      last: null,
    };
  },
  mounted() {
    this.fetchOverview();
    this.fetchDeadline();
  },
  methods: {
    fetchOverview() {
      this.loading = true;

      let data = {
        path: `overview/${
          this.permissions.includes("TEACHER")
            ? "teacher"
            : "fasilitator-mentor"
        }`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        this.overview = data.data;
        this.last = data.data.length;
        this.loading = false;
      });
    },
    fetchDeadline() {
      this.loading = true;
      let data = {
        path: `overview/${
          this.permissions.includes("TEACHER")
            ? "teacher"
            : "fasilitator-mentor"
        }/deadline`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        this.deadline = data.data;
        this.loading = false;
      });
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    toPrivateChat(item) {
      localStorage.setItem("with", item.user_id);
      this.$router.push(`/networking/net/management-networking/private-chat`);
    },
  },
};
</script>

<style scoped>
.progress-circular >>> circle {
  stroke-linecap: round;
}
.around_m {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #99c1b4;
}
.txtRunning {
  color: #a2aaad;
}
.expand_member {
  position: relative;
  height: max-content;
  transition: 0.5 all;
  margin-bottom: 10px;
}
.collapse_member {
  position: relative;
  overflow: hidden;
  height: max-content;
  transition: 0.5 all;
  margin-bottom: 10px;
}
.control_height {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: -100px;
  left: 0;
  width: 100%;
  border-radius: 10px;
  z-index: -1;
}
.btn_toogle {
  color: transparent;
}
.expand_history {
  position: relative;
  height: max-content;
  transition: 0.5 all;
}
.collapse_history {
  position: relative;
  overflow: hidden;
  height: max-content;
  transition: 0.5 all;
  padding: 20px;
}
.trigger_timeline {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: -100px;
  left: 0;
  width: 100%;
  z-index: -1;
}
.btn_trigger_timeline {
  color: transparent;
}
.historyDefault {
  height: max-content;
  z-index: 0;
}
.coming_course {
  margin-right: 10px;
}
.complete_course {
  margin-left: 10px;
}
.txtLarge {
  font-size: 36px;
}
.txtMedium {
  font-size: 32px;
}
.txtMediumSmall {
  font-size: 24px;
}
.txtSmall {
  font-size: 18px;
}
.txtExtraSmall {
  font-size: 14px;
}
.txt_date {
  font-size: 14px;
}
.colorGrey {
  background-color: #edf1f0;
}
.colorWhite {
  background-color: white;
}
.expand_scholar {
  position: relative;
  height: max-content;
  transition: 0.5 all;
}
.collapse_scholar {
  position: relative;
  overflow: hidden;
  height: max-content;
  transition: 0.5 all;
}
.btn_showScholar {
  position: absolute;
  bottom: 5px;
}
.parent_btn_showScholar {
  position: absolute;
  z-index: -1;
}
@media (max-width: 768px) {
  .expand_scholar {
    position: relative;
    height: max-content;
    transition: 0.5 all;
    margin-bottom: 20px;
  }
  .collapse_scholar {
    position: relative;
    overflow: hidden;
    max-height: 165px;
    transition: 0.5 all;
    margin-bottom: 25px;
  }
  .btn_showScholar {
    position: absolute;
    bottom: 5px;
  }
  .parent_btn_showScholar {
    position: inherit;
    z-index: 1;
  }
  .coming_course {
    margin: 0;
  }
  .complete_course {
    margin-top: 20px;
    margin-left: 0px;
  }
  .expand_member {
    position: relative;
    height: max-content;
    transition: 0.5 all;
    margin-bottom: 10px;
  }
  .collapse_member {
    position: relative;
    overflow: hidden;
    height: 90px;
    transition: 0.5 all;
    margin-bottom: 10px;
  }
  .control_height {
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 10px;
    z-index: 1;
  }
  .btn_toogle {
    color: #a2aaad;
  }
  .expand_history {
    padding: 0 20px 0 20px;
    position: relative;
    height: max-content;
    overflow: hidden;
    transition: 0.5 all;
  }
  .collapse_history {
    padding: 30px;
    position: relative;
    overflow: hidden;
    height: 80px;
    transition: 0.5 all;
  }
  .trigger_timeline {
    position: absolute;
    display: flex;
    justify-content: center;
    background-color: white;
    top: 0;
    padding: 5px;
    height: 35px;
    left: 0;
    z-index: 2;
    width: 100%;
  }
  .btn_trigger_timeline {
    color: #a2aaad;
  }
  .historyDefault {
    width: 100%;
    height: 100vh;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: #edf1f0;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .txtLarge {
    font-size: 20px;
  }
  .txtMedium {
    font-size: 20px;
  }
  .txtMediumSmall {
    font-size: 18px;
  }
  .txtSmall {
    font-size: 12px;
  }
  .txtExtraSmall {
    font-size: 11px;
  }
}
</style>
